// extracted by mini-css-extract-plugin
export default {"root":"SearchInfoBanner_root__ht1Vy","headings":"SearchInfoBanner_headings__mQSYH"};